import { COLORS, SEAT_SIZE, TABLE } from '../constants';
import { Group } from 'konva/lib/Group';
import { Circle } from 'konva/lib/shapes/Circle';

class TableCircle {
	options: any = {};
	draggable = true;
	element = new Group({
		draggable: true,
	});
	shape: any;
	seats: any;

	sizes: any = {
		s: 25,
		m: 35,
		l: 45,
		xl: 50,
	};

	radius: any = this.sizes.s;

	constructor(options = {}) {
		this.options = options;

		this.element.x(-this.radius)
		this.element.y(-this.radius)

		this.initShape();
		this.initSeats();
		this.reorder();
	}

	private initShape() {
		this.radius = this.sizes[`${this.options.size}`];

		this.shape = new Circle({
			x: this.radius,
			y: this.radius,
			radius: this.radius,
			fill: 'white',
			stroke: 'black',
			strokeWidth: 2,
		});

		this.element.add(this.shape);
	}

	private initSeats() {
		const TAU = Math.PI * 2;
		const isBarChair = this.options.size == TABLE.SIZES.S && this.options.capacity == 1;

		let seats = new Group({ name: 'seats' });
		this.seats = seats;

		const seatShape = new Circle({
			x: 0,
			y: 0,
			radius: SEAT_SIZE,
			fill: COLORS.SEATS.INACTIVE,
		});

		for (let i = 0; i < this.options.capacity; i++) {
			const seat = seatShape.clone();

			seat.y(this.radius + Math.cos(i * (TAU / this.options.capacity)) * this.radius);
			seat.x(this.radius + Math.sin(i * (TAU / this.options.capacity)) * this.radius);

			seats.add(seat);
		}

		if (isBarChair) {
			seats.children[0].hide();
		}

		this.element.add(seats);
	}

	private reorder() {
		this.element.children[1].zIndex(0);
	}
}

export default TableCircle;
